<template lang="">
  <BBadge
    v-if="remark"
    class="badge-remark px-75"
    :variant="remarkObj?.variant ? `light-${remarkObj?.variant}` : 'light-secondary'"
    pill
  >
    {{ remarkObj?.text ?? remark }}
  </BBadge>
</template>
<script>
import { computed } from '@vue/composition-api'
import { BBadge } from 'bootstrap-vue'

import store from '@/store'
import VueI18n from '@/libs/i18n'

export default {
  components: { BBadge },
  props: {
    remark: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const REMARK_GLOBAL_CONFIG_KEY = 'flightsScheduleRemarks'
    const remarksList = computed(() => store.getters['globalConfig/getConfig'](REMARK_GLOBAL_CONFIG_KEY) ?? [])

    const locale = computed(() => VueI18n.locale)
    function getRemarkByKey(key, language = locale) {
      const foundItem = remarksList.value?.find(remark => remark.key === key)
      if (!foundItem) {
        return null
      }
      return language === 'vi' ? foundItem.viValue : foundItem.value
    }

    const remarkObj = computed(() => getRemarkByKey(props.remark, locale.value))
    return {
      remarkObj,
    }
  },
}
</script>
<style lang="scss" scoped>
.badge-remark {
  &.badge-light-info {
    color: #166987 !important;
    background-color: #16698723;
  }
  &.badge-light-warning {
    color: #FF9F00 !important;
    background-color: #FF9F0023;
  }
  // &.badge-light-danger {
  //   color: #EF5350 !important;
  //   background-color: #ef53501f;
  // }
}
</style>
